<script setup lang="ts">
import { ref } from 'vue'
import { Data } from '@/stores/data'

let def = defineProps({
  itemData: {
    type: Object,
    default: () => ({})
  },
  showGoBtn: {
    type: Boolean,
    default: () => false
  },
  showDeleteBtn: {
    type: Boolean,
    default: () => false
  },
  showAddBtn: {
    type: Boolean,
    default: () => false
  }
})
const $emit = defineEmits(['clickApplicationItemBtn', 'addApplicationBtn', 'deleteApplicationBtn'])
let showUseBtn = ref(false)
function clickApplicationItemBtn() {
  $emit('clickApplicationItemBtn', def.itemData)
}
function addApplicationBtn() {
  $emit('addApplicationBtn', def.itemData)
}
function deleteApplicationBtn() {
  $emit('deleteApplicationBtn', def.itemData)
}
function hoverHandler() {
  if (!Data.isLogin.value) {
    return
  }
  // console.log(def.itemData)
  showUseBtn.value = true
}
function leaveHandler() {
  if (!Data.isLogin.value) {
    return
  }
  console.log(1)
  showUseBtn.value = false
}
</script>

<template>
  <div class="large-item" v-if="itemData.resourceType == 'lesson' || itemData.resourceType == 'courseware'"
    @click="clickApplicationItemBtn" v-on:mouseover="hoverHandler" v-on:mouseleave="leaveHandler"
    :style="itemData.resourceType == 'courseware' ? 'margin-right: 0' : ''">
    <div class="large-item-ctr">
      <div class="large-left">
        <div class="large-item-title">{{ itemData.name }}</div>
        <div class="large-item-information">{{ itemData.info }}</div>
        <div class="large-left-info">
          <div class="left-info-name">学科内容生成</div>
          <div class="left-info-shadow" style="width: 94px"></div>
        </div>
        <div class="large-left-info">
          <div class="left-info-name">全学科/年段覆盖</div>
          <div class="left-info-shadow" style="width: 116px"></div>
        </div>
        <div class="large-left-info">
          <div class="left-info-name">自定义个性化编改</div>
          <div class="left-info-shadow" style="width: 122px"></div>
        </div>
      </div>
      <div class="large-right">
        <img class="right-bg-img" :src="itemData.bgImg" alt="">
        <img :class="itemData.resourceType == 'lesson' ? 'right-tip-img' : 'right-cwtip-img'" :src="itemData.tipImg" alt="">
        <div class="large-right-btn">
          <img src="@/assets/large-btn-icon.png" class="large-btn-icon" alt="" />
          开始生成
        </div>
      </div>
    </div>
  </div>
  <div class="application-item" @click="clickApplicationItemBtn" v-on:mouseover="hoverHandler"
    v-on:mouseleave="leaveHandler" v-else>
    <div class="img-ctr">
      <img :src="itemData.icon" class="item-icon" :class="{ 'notFinished-icon': !itemData.status }" alt="" />
    </div>
    <div style="flex: 1" class="item-ctr" :class="{ 'notFinished': !itemData.status }">
      <div class="item-title">{{ itemData.name }}</div>
      <div class="item-information">{{ itemData.info }}</div>
    </div>
    <div class="btn-ctr">
      <el-button link class="add-btn" @click.stop="addApplicationBtn" v-if="showAddBtn">添加</el-button>
      <el-button link class="delete-btn" @click.stop="deleteApplicationBtn" v-if="showDeleteBtn" disabled>移除</el-button>
      <div class="go-button" v-if="showGoBtn">
        <img class="arrow-img" src="@/assets/arrow.png" alt="" />
      </div>

      <div class="use-btn" v-show="itemData.status == true && showUseBtn == true">
        使用
        <img src="@/assets/use-icon.png" class="use-icon" alt="" />
      </div>
    </div>
    <div class="wait-btn" v-show="itemData.status == false">
      <img src="@/assets/wait.png" class="wait-icon" alt="" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.application-item {
  width: 303px;
  height: 100px;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  margin-right: 16px;
  margin-bottom: 16px;
  flex-shrink: 0;
}

.application-item:hover {
  cursor: pointer;
  transform: translateY(-2px);
  transition: 0.2s;
  backdrop-filter: blur(4px);
  box-shadow: 0 4px 10px 0 rgba(158, 172, 229, 0.3);
}

@media only screen and (min-width: 1440px) {
  .application-item {
    width: calc((100% - 64px) /4);
  }

  .large-left-info {
    margin-top: 34px;
  }
}

@media only screen and (max-width: 1439px) {
  .application-item {
    width: calc((100% - 48px) /3);
    min-width: 303px;
  }

  .large-left-info {
    margin-top: 24px;
  }
}

.img-ctr {
  width: 96px;
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 26px;
}

.item-ctr {
  color: #040a39;
}

.notFinished {
  opacity: 0.5;
}

.item-icon {
  width: 56px;
  height: auto;
  max-height: 56px;
}

.notFinished-icon {
  filter: blur(2px);
}

.item-title {
  font-size: 16px;
  font-weight: bold;
  line-height: 16px;
  letter-spacing: 0;
  margin-bottom: 12px;
  margin-top: 3px;
}

.item-information {
  font-size: 14px;
  font-weight: normal;
  line-height: 16px;
  letter-spacing: 0;
  font-feature-settings: 'kern' on;
}

.btn-ctr {
  height: 57px;
}

.delete-btn {
  font-size: 14px;
  font-weight: normal;
  line-height: 16px;
  letter-spacing: 0;
  font-feature-settings: 'kern' on;
  color: #485cec;
  padding-right: 19px;
  margin-left: 15px;
}

.go-button {
  width: 30px;
  height: 30px;
  background: rgba(72, 92, 236, 0.1);
  border-radius: 50%;
  margin-right: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 13px;
}

.arrow-img {
  width: 16px;
  height: 16px;
}

.use-btn {
  width: 60px;
  height: 24px;
  background: linear-gradient(90deg, #627dff 0%, #9389ff 100%);
  border-radius: 116px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  //margin-right: 11px;
  font-size: 14px;
  font-weight: normal;
  line-height: 16px;
  position: absolute;
  right: 14px;
  top: 10px;
}

@keyframes moveLeftRight {
  0% {
    transform: translateX(0);
  }

  50% {
    transform: translateX(4px);
    /* 向右移动 */
  }

  100% {
    transform: translateX(0);
    /* 回到初始位置 */
  }
}

.use-icon {
  width: 12px;
  height: 12px;
  margin-left: 2px;
  animation: moveLeftRight 0.5s ease-in-out infinite;
}

.wait-btn {
  width: 86px;
  height: auto;
  position: absolute;
  right: 8px;
  top: 4px;
}

.wait-icon {
  width: 86px;
  height: auto;
}

.large-item {
  width: calc((100% - 38px) /2);
  min-width: 492px;
  border-radius: 12px;
  background: #FFFFFF;
  margin-right: 38px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  padding: 24px;
}

.large-item:hover {
  cursor: pointer;
  transform: translateY(-4px);
  transition: 0.2s;
  backdrop-filter: blur(4px);
  box-shadow: 0 4px 10px 0 rgba(158, 172, 229, 0.3);
}

.large-item-ctr {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
}

.large-left {
  width: 174px;
  height: 100%;
}

.large-item-title {
  font-family: Alimama ShuHeiTi;
  font-size: 22px;
  font-weight: bold;
  line-height: normal;
  color: #040A39;
  margin-bottom: 10px;
}

.large-item-information {
  font-family: Source Han Sans;
  font-size: 14px;
  font-weight: normal;
  line-height: 16px;
  color: #040A39;
}

.large-left-info {
  font-family: Alimama ShuHeiTi;
  font-size: 14px;
  font-weight: bold;
  line-height: 16px;
  color: #040A39;
  height: 22px;
  position: relative;
  z-index: 1000;
}

.left-info-name {
  position: relative;
  z-index: 1000;
  margin-left: 5px;
  margin-bottom: 5px;
}

.left-info-shadow {
  border-radius: 30px 2px 37px 2px;
  opacity: 1;
  height: 12px;
  background: #D6D5FF;
  position: absolute;
  z-index: 100;
  bottom: 0;
  left: 0;
}

.large-right {
  height: auto;
  position: relative;
  flex: 1;
  max-width: 390px;
  max-height: 283px;
}

.right-bg-img {
  width: 100%;
  max-width: 390px;
  height: auto;
  max-height: 283px;
}

.right-tip-img {
  position: absolute;
  width: 158px;
  height: 64px;
  left: -11.5%;
  top: 42.7%;

}

.right-tip-img:hover {
  transition: transform .3s ease-in-out;
  transform: translateY(0);
}

@keyframes float-left {
  0% {
    opacity: 0;
    transform: translateX(-45px);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.right-cwtip-img {
  width: 142px;
  height: 48px;
  position: absolute;
  left: -9%;
  top: 53%;
}

.large-right-btn {
  width: 55.8%;
  height: 36px;
  border-radius: 29px;
  background: linear-gradient(90deg, #475EFF 8%, #EB6EED 91%);
  background-size: 400% 400%;
  box-shadow: inset 0px 0px 10px 4px rgba(255, 255, 255, 0.3);
  color: #FFFFFF;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 6%;
  border: none;
  right: 50%;
  transform: translateX(50%);
  animation: slide 3s ease infinite;
}

.large-right-btn:hover {
  background: linear-gradient(90deg, #475EFF 8%, #EB6EED 91%);
  border: none !important;
}

@keyframes slide {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

.large-btn-icon {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}</style>
